export default __webpack_public_path__ + "static/media/home-bg-august.462dc068.png";